import { Component, input, output } from '@angular/core';

interface Icon {
  variant: 'none' | 'right' | 'left' | 'alone';
  path?: string;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.html',
})
export class Button {
  color = input<
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'neutral'
  >();
  type = input<'button' | 'submit' | 'reset'>('button');
  size = input<'small' | 'medium' | 'large'>('medium');
  label = input<string>('');
  icon = input<Icon>();
  loading = input(false);
  disabled = input(false);
  id = input<string>('');

  clicked = output<void>();

  GetButtonClass(): string {
    switch (this.color()) {
      case 'primary':
        return 'btn-primary';
      case 'secondary':
        return 'btn-secondary';
      case 'accent':
        return 'btn-accent';
      case 'info':
        return 'btn-info';
      case 'success':
        return 'btn-success';
      case 'warning':
        return 'btn-warning';
      case 'error':
        return 'btn-error';
      case 'neutral':
        return 'btn-neutral';
      default:
        return '';
    }
  }

  GetButtonSize(): string {
    switch (this.size()) {
      case 'small':
        return 'btn-sm';
      case 'medium':
        return 'btn-md';
      case 'large':
        return 'btn-lg';
      default:
        return 'btn-md';
    }
  }

  GetButtonHover(): string {
    if (this.disabled() || this.loading()) {
      return '!cursor-not-allowed';
    }
    return 'cursor-pointer';
  }

  onClick() {
    if (!this.disabled() && !this.loading()) {
      this.clicked.emit();
    }
  }
}
